<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <div class="h-input-group" v-width="320">
          <DatePicker v-model="params.start" style="width: 130px" :clearable="false" :option="{end:params.end}"
                      format="YYYY-MM-DD"></DatePicker>
          <span class="h-input-addon">至</span>
          <DatePicker v-model="params.end" style="width: 130px" :clearable="false" :option="{start:params.start}"
                      format="YYYY-MM-DD"></DatePicker>
        </div>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button color="primary" @click="add">新增</Button>
        <Button icon="fa fa-print" @click="doPrint">打印</Button>
        <DropdownMenu button @click="importTrigger" :datas="importDatas">导入</DropdownMenu>
        <Button @click="doExport">导出</Button>
        <Button color="red" @click="batchRemove">批量删除</Button>
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="transferList" :border="true" :loading="loading">
        <TableItem :width="40" align="center">
          <div slot-scope="{data}">
            <input type="checkbox" v-model="data._checked" :disabled="!!data.voucherId">
          </div>
        </TableItem>
        <TableItem title="日期" prop="billDate" :width="110"></TableItem>
        <TableItem title="摘要" prop="summary" :width="160"></TableItem>
        <TableItem title="转出账户" :width="140">
          <template slot-scope="{data}">{{ accountName(data.fromAccountId) }}</template>
        </TableItem>
        <TableItem title="转入账户" :width="140">
          <template slot-scope="{data}">{{ accountName(data.toAccountId) }}</template>
        </TableItem>
        <TableItem title="金额" :width="140" align="right">
          <template slot-scope="{data}">{{ data.amount | numFormat }}</template>
        </TableItem>
        <TableItem title="备注" prop="remark"></TableItem>
        <TableItem title="关联凭证" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag h-tag-bg-blue" v-if="data.voucherId">已生成</span>
            <span v-else>-</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="160">
          <div class="actions" slot-scope="{data}">
            <span @click="generateVoucher(data)" v-if="!data.voucherId">生成凭证</span>
            <span @click="edit(data)">编辑</span>
            <span @click="remove(data)" v-if="!data.voucherId">删除</span>
          </div>
        </TableItem>
      </Table>
      <Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
                  @change="currentChange" small align="right"/>
    </div>

    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">内部转账</div>
      <Form ref="form" v-width="420" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="日期" prop="billDate">
          <DatePicker type="date" v-model="form.billDate" format="YYYY-MM-DD"></DatePicker>
        </FormItem>
        <FormItem label="转出账户" prop="fromAccountId">
          <Select v-model="form.fromAccountId" :datas="accountList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
        <FormItem label="转入账户" prop="toAccountId">
          <Select v-model="form.toAccountId" :datas="toAccountList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
        <FormItem label="金额" prop="amount">
          <NumberInput :min="0.01" v-model="form.amount"></NumberInput>
        </FormItem>
        <FormItem label="摘要" prop="summary">
          <input type="text" v-model="form.summary">
        </FormItem>
        <FormItem label="备注">
          <input type="text" v-model="form.remark">
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>

    <!--隐藏的文件选择框-->
    <input ref="transferImportInput" type="file" accept=".xlsx,.xls" style="display:none"
           @change="onImportFileChange">
  </div>
</template>

<script>
import moment from 'moment';
import {exportCsv} from '../../js/common/export-file';

const emptyForm = {
  billDate: null,
  fromAccountId: null,
  toAccountId: null,
  amount: null,
  summary: '内部转账',
  remark: ''
};

export default {
  name: 'InternalTransfer',
  data() {
    return {
      accountList: [],
      transferList: [],
      params: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['billDate', 'fromAccountId', 'toAccountId', 'amount', 'summary']
      },
      showForm: false,
      loading: false,
      importDatas: [
        {title: '下载导入模板', key: 'template'},
        {title: '导入转账数据', key: 'import'}
      ]
    }
  },
  computed: {
    toAccountList() {
      return this.accountList.filter(account => account.id !== this.form.fromAccountId);
    }
  },
  methods: {
    accountName(id) {
      let account = this.accountList.find(item => item.id === id);
      return account ? account.name : '-';
    },
    loadBase() {
      this.$api.funds.account.list().then(({data}) => {
        this.accountList = data || [];
      }).catch(() => {
      });
    },
    loadList() {
      this.loading = true;
      this.$api.funds.transfer.list(Object.assign({}, this.params, {
        page: this.pagination.page,
        size: this.pagination.size
      })).then(({data}) => {
        this.transferList = (data.results || data.records || data || []).map(item => Object.assign({_checked: false}, item));
        this.pagination.total = data.total || 0;
      }).catch(() => {
        this.$Message.error('内部转账数据加载失败');
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
    },
    currentChange() {
      this.loadList();
    },
    add() {
      this.form = Object.assign({}, emptyForm, {billDate: moment().format('YYYY-MM-DD')});
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, data);
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      if (this.form.fromAccountId === this.form.toAccountId) {
        this.$Message.error('转出账户与转入账户不能相同！');
        return;
      }
      this.loading = true;
      let data = Object.assign({}, this.form, {
        billDate: moment(this.form.billDate).format('YYYY-MM-DD')
      });
      this.$api.funds.transfer[data.id ? 'update' : 'save'](data).then(() => {
        this.$Message('保存成功~');
        this.showForm = false;
        this.loadList();
      }).catch(() => {
        this.$Message.error('内部转账保存失败');
      }).finally(() => this.loading = false);
    },
    remove(data) {
      this.$Confirm('确认删除该笔内部转账？').then(() => {
        this.$api.funds.transfer.delete(data.id).then(() => {
          this.$Message('删除成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('删除失败');
        });
      });
    },
    batchRemove() {
      let ids = this.transferList.filter(item => item._checked && !item.voucherId).map(item => item.id);
      if (!ids.length) {
        this.$Message.error('请勾选需要删除的转账记录！');
        return;
      }
      this.$Confirm(`确认删除选中的 ${ids.length} 笔内部转账？`).then(() => {
        this.loading = true;
        Promise.all(ids.map(id => this.$api.funds.transfer.delete(id))).then(() => {
          this.$Message('批量删除成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('批量删除失败');
        }).finally(() => this.loading = false);
      });
    },
    generateVoucher(data) {
      this.$Confirm('确认为该笔内部转账生成凭证？').then(() => {
        this.loading = true;
        this.$api.funds.transfer.generateVoucher(data.id).then(() => {
          this.$Message('凭证生成成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('凭证生成失败');
        }).finally(() => this.loading = false);
      });
    },
    doPrint() {
      window.print();
    },
    importTrigger(key) {
      if (key === 'template') {
        window.open(this.$api.funds.transfer.template());
      } else {
        this.$refs.transferImportInput.click();
      }
    },
    onImportFileChange(e) {
      let file = e.target.files[0];
      e.target.value = '';
      if (!file) return;
      let formData = new FormData();
      formData.append('file', file);
      this.loading = true;
      this.$api.funds.transfer.importData(formData).then(({data}) => {
        this.$Message(`导入完成：成功 ${data.successCount} 笔，跳过 ${data.skippedCount} 笔`);
        (data.messages || []).slice(0, 5).forEach(msg => this.$Message.error(msg));
        this.pagination.page = 1;
        this.loadList();
      }).catch(() => {
        this.$Message.error('内部转账导入失败');
      }).finally(() => this.loading = false);
    },
    doExport() {
      let headers = ['日期', '摘要', '转出账户', '转入账户', '金额', '备注', '关联凭证'];
      let rows = this.transferList.map(data => [
        data.billDate, data.summary, this.accountName(data.fromAccountId), this.accountName(data.toAccountId),
        data.amount, data.remark, data.voucherId ? '已生成' : ''
      ]);
      exportCsv('内部转账', headers, rows);
    }
  },
  mounted() {
    this.loadBase();
    this.loadList();
  }
}
</script>
